import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import {
  heroArrowPath,
  heroChevronRight,
  heroMoon,
  heroSun,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { ccmsApiInterceptor } from './core/interceptors/ccms-api.interceptor';
import { SupplierAuthService } from './core/services/supplier-auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    provideAppInitializer(() => inject(SupplierAuthService).restoreSession()),
    provideHttpClient(withInterceptors([ccmsApiInterceptor])),
    provideIcons({
      heroArrowPath,
      heroChevronRight,
      heroMoon,
      heroSun,
      heroXMark,
    }),
  ],
};
